export default  {
    motivosRecusa: {
        CUSTO_SUPERIOR: 1,
        COBERTURAS_NAO_ATENDEM: 2,
        SEGURADO_DESISTIU: 3,
        QUESTAO_COMERCIAL_PARCERIA: 4,
        OUTRO_MOTIVO:5
    }
}



// WEBPACK FOOTER //
// ./src/helpers/motivo-recusa-enum.js